import { productService, type ProductCategoryFilters } from "~/services/productService";
import type { APIProduct } from "~~/shared/types/product";

export const useCategoryProducts = (
    slug?: string | null,
    // allow passing a ref or plain object for filters so callers can pass reactive refs
    filters?: Ref<ProductCategoryFilters | undefined>
) => {
    if (!slug) return { data: ref(null), pending: ref(false), refresh: () => {} };

    // compute key from the current, deeply-unwrapped filters value so the key changes when nested refs update
    const key = computed(() => `northland:category-products:${slug}:${JSON.stringify(unref(filters) ?? {})}`);

    return useAsyncData<{ category: APICategory; products: APIProduct[] } | null>(
        key,
        async () => {
            // pass the deeply-unwrapped filters to the service so nested refs are resolved to plain values
            const currentFilters = unref(filters);
            const res = await productService.getCategoryProducts(slug, currentFilters);
            return res?.data ?? null;
        },
        { dedupe: "cancel" }
    );
};
